<template>
  <div class="dimmed" v-show="isChecking">
    <content-box width="360px" min-height="250px" class="loading--wrap">
      <ui-loading-circle>
        <span class="loading_notice" v-html="$t('common.trackingCode.checkingInstall')"></span>
      </ui-loading-circle>
    </content-box>
  </div>
</template>

<script>
import { getDialog } from '@/libs/vue-utils'
import { checkInstall } from '@/api/apply'
import ContentBox from '@/components/ui/ContentBox'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'

const openDialog = getDialog('dialogType')

export default {
  name: 'InstallChecker',
  components: {
    ContentBox,
    UiLoadingCircle
  },
  props: [
    'checkerData'
  ],
  data () {
    return {
      isChecking: true
    }
  },
  created () {
    checkInstall(this.checkerData.aid, this.checkerData.url).then(data => {
      this.isChecking = false
      openDialog('dashboard.trackingCodeInstalled').then(() => {
        this.onDone(true)
      })
    }).catch(err => {
      this.isChecking = false
      // todo: handle other error type
      let dialogType
      let needReload = false
      switch (err.message) {
        case 'Already Installed':
          dialogType = 'dashboard.trackingCodeInstalled'
          needReload = true
          break
        case 'Not installed':
          dialogType = 'dashboard.trackingCodeNotInstalled'
          break
        case 'Login page':
          dialogType = 'dashboard.trackingCodeLoginPage'
          break
        case 'Network Error':
          dialogType = 'dashboard.trackingCodeNetworkingError'
          break
        case 'Not found':
          dialogType = 'dashboard.trackingCodeCheckFailed'
          needReload = true
          break
        default:
          dialogType = 'dashboard.trackingCodeCheckFailed'
      }
      openDialog(dialogType).then(() => {
        this.onDone(needReload)
      })
    })
  },
  methods: {
    onDone (needReload) {
      this.$emit('onDone', needReload)
    }
  }
}
</script>

<style lang="scss" scoped>
.loading--wrap {
  @include positionXYcenter;
  padding-top: 35px;
  box-sizing: border-box;
  text-align: center;

  .loading_notice {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
    padding-top: 20px;
  }

  .loading {
    position: relative;
    top: 0;
    left: 0;
    transform: translate(0, 0);

    /deep/ svg {
      width: 75px;
      height: 75px;
    }
  }
}
</style>
